module.exports = {

    // Change this to your firebase configuration! (Add Firebase to your web app)
    FIREBASE_CONFIG: {

        apiKey: "AIzaSyDx8Pgi1sbSo7cbTBQr2I6SysbKLwwM2Iw",
        authDomain: "aura-e9471.firebaseapp.com",
        databaseURL: "https://aura-e9471.firebaseio.com",
        storageBucket: "aura-e9471.appspot.com",
        messagingSenderId: "871393065745"

    }
};



// WEBPACK FOOTER //
// ./src/app/config.js